export enum TileType {
    Standard = '-',
    Gap = ' ',
    Boost = 'B', // Add Speed Boost tile type
    SlowMotion = 'S', // Add Slow Motion
    Finish = 'F', // Add Finish Line tile type
    // Add more tile types here later (e.g., Boost = 'B')
}

export interface LevelData {
    name: string;
    timeLimit: number; // in seconds
    track: string[]; // Array of strings, each representing a row
} 